import React, { useContext, useEffect } from "react";

import classnames from "classnames";

import moment from "moment";
import {
  ReportsDateProvider,
  DashboardTitle,
  DashboardEmptyResponse
} from "../Dashboard";
import { getEntity } from "../../../Helpers/IOClient";
import {
  ContractsOpenChart,
  ProjectsActivityChart
} from "../Echarts/AverageEvolutionTicketsLineChart";
import { BarLoader } from "../../../Components/GlobalLoader/GlobalLoader";
import { ComboLoadChart } from "../Echarts/TicketLoadBarChart";
import { spacePipelineSchema } from "../../../config/schema";
import { ProjectMainViewLink } from "../../../Helpers/HooksHelper";
import { useCurrentAccount } from "../../../Contexts/UserContext";
import { FormattedMessage } from "react-intl";
import { useDashboardQuery } from "../DashboardQueryHelper";
import { useSidebar } from "../../../Components/Sidebar/SidebarV2";
import { DashboardSettingsContext } from "../DashboardLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/pro-light-svg-icons";
import DashboardCardSettingsForm, {
  handleIntervalCalculation
} from "../DashboardCardSettingsForm";
import Button from "../../../Components/Button/Button";
import CreateDashboardFilterLinksHelper from "../DashboardFilterLinksHelper";

const defaultTimeFrame = moment().subtract(180, "d").format("YYYY-MM-DD");
const lS_Group = "dashboard-layout-projetos";
export const OpenProjectsEvolution = () => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "openEvolutionProjects";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings =
    (DashboardSettings &&
      DashboardSettings[lS_Group] &&
      DashboardSettings[lS_Group][lS_Field]) ||
    {};

  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);

  const { ...DataReports } = useContext(ReportsDateProvider);
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/Projects/OpenEvolution?todate=${
      DataReports[0] === "Projects"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Projects"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? defaultTimeFrame
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : defaultTimeFrame
    }${
      DataReports[0] === "Projects"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  const user =
    DataReports[0] === "Projects" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );
  if (!loading && !error) {
    const { Results, HasData } = data;

    return (
      <div className="px-3 of-hidden h-100 d-flex flex-column">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"PROJECTS_OPEN_EVOLUTION"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Projects" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                {Settings.Interval ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"180DAYS"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    Title={"PROJECTS_OPEN_EVOLUTION"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: false
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}
        <div className="h-100">
          {HasData ? (
            <ContractsOpenChart Data={Results} />
          ) : (
            <DashboardEmptyResponse className="h-100" type="projects">
              <FormattedMessage id={"EMPTY_PROJECTS"} />
            </DashboardEmptyResponse>
          )}
          {/* {Results.Total === 0 ? (
            <DashboardEmptyResponse type="projects">
              <FormattedMessage id={"EMPTY_RPOJECTS"} />
            </DashboardEmptyResponse>
          ) : (
            <ContractsOpenChart Data={Results} />
          )} */}
        </div>
      </div>
    );
  } else {
    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};

export const WorkloadProjects = () => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "WorkloadProjects";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings =
    (DashboardSettings &&
      DashboardSettings[lS_Group] &&
      DashboardSettings[lS_Group][lS_Field]) ||
    {};

  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);

  const { ...DataReports } = useContext(ReportsDateProvider);
  const { data, loading, error } = useDashboardQuery(
    `Dashboard/Services/Projects/assigned?top=7&todate=${
      DataReports[0] === "Projects"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Projects"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : ""
    }${
      DataReports[0] === "Projects"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  const user =
    DataReports[0] === "Projects" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );
  if (!loading && !error) {
    const Results = data;

    let HasData = false;
    for (const e of Results) {
      const { Data } = e;
      for (const key in Data) {
        if (Object.hasOwnProperty.call(Data, key)) {
          const element = Data[key];
          if (parseInt(element) > 0) {
            HasData = true;
            break;
          }
        }
      }
      if (HasData) {
        break;
      }
    }
    // resolvedData.Data["1"] = 0;
    return (
      <div className="px-3 of-hidden h-100 d-flex flex-column">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"OPEN_PROJECT_ATRIBUTED"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Projects" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                {Settings.Interval ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    Title={"OPEN_PROJECT_ATRIBUTED"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: false
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}

        <div className="h-100 d-flex">
          {/* {Results.length <= 1 && Results[0].Total === 0 ? (
            <DashboardEmptyResponse className="h-100" type="projects">
              <FormattedMessage id={"EMPTY_PROJECTS"} />
						</DashboardEmptyResponse>
						
          ) : (
            <ComboLoadChart Data={Results} />
          )} */}
          {HasData ? (
            <ComboLoadChart Data={Results} />
          ) : (
            <DashboardEmptyResponse className="h-100" type="projects">
              <FormattedMessage id={"EMPTY_PROJECTS"} />
            </DashboardEmptyResponse>
          )}
        </div>
      </div>
    );
  } else {
    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};

export const ProjectActivityEvolution = () => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "ProjectsActivity";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings =
    (DashboardSettings &&
      DashboardSettings[lS_Group] &&
      DashboardSettings[lS_Group][lS_Field]) ||
    {};

  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);

  const { ...DataReports } = useContext(ReportsDateProvider);
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/Projects/activity?top=15&todate=${
      DataReports[0] === "Projects"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Projects"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : ""
    }${
      DataReports[0] === "Projects"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  const user =
    DataReports[0] === "Projects" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );
  if (!loading && !error) {
    const Results = data;
    let HasData = false;
    for (const e of Results) {
      const { Data } = e;
      for (const key in Data) {
        if (Object.hasOwnProperty.call(Data, key)) {
          const element = Data[key];
          if (parseInt(element) > 0) {
            HasData = true;
            break;
          }
        }
      }
      if (HasData) {
        break;
      }
    }
    return (
      <div className="px-3 of-hidden h-100 d-flex flex-column">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"PROJECTS_ACTIVITY"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Projects" && (
          <div className="d-flex  justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                {Settings.Interval ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    Title={"PROJECTS_ACTIVITY"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: false
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}
        <div className="h-100 d-flex">
          {HasData ? (
            <ProjectsActivityChart Data={Results} />
          ) : (
            <DashboardEmptyResponse className="h-100" type="projects">
              <FormattedMessage id={"EMPTY_PROJECTS"} />
            </DashboardEmptyResponse>
          )}

          {/* {Results.Total === 0 ? (
            <DashboardEmptyResponse className="h-100" type="projects">
						<FormattedMessage id={"EMPTY_PROJECTS"} />
					</DashboardEmptyResponse>
          ) : (
            <ProjectsActivityChart Data={Results} />
          )} */}
        </div>
      </div>
    );
  } else {
    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};

export const ProjectStatusTotals = () => {
  const { data, error, loading } = useDashboardQuery("query/Pipelines?Type=1", [
    spacePipelineSchema
  ]);

  if (!loading && !error) {
    return <ProjectStatusTotalsResult results={data} />;
  } else {
    return <BarLoader style={{ marginTop: -16 }} isLoading={loading} />;
  }
};

const ProjectStatusTotalsResult = ({ results }) => {
  const [openSidebar, closeSidebar] = useSidebar();
  const lS_Field = "ProjectStates";

  const DashboardSettings =
    JSON.parse(localStorage.getItem("ar-dashboard-settings")) || {};
  const Settings = (DashboardSettings &&
    DashboardSettings[lS_Group] &&
    DashboardSettings[lS_Group][lS_Field]) || { Pipeline: results[0] };
  const handleLayoutChange = useContext(DashboardSettingsContext);

  useEffect(() => {
    return () => closeSidebar();
  }, [closeSidebar]);

  const { ...DataReports } = useContext(ReportsDateProvider);
  const pipeline =
    DataReports[0] === "Projects" ? DataReports[3] : Settings.Pipeline;
  const { data, error, loading } = useDashboardQuery(
    `Dashboard/Services/Projects/PipelineStatus?pipelineid=${
      pipeline ? pipeline : Settings.Pipeline
    }&todate=${
      DataReports[0] === "Projects"
        ? DataReports[1].toDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "toDate",
              Settings.Interval
            )
        : ""
    }&fromdate=${
      DataReports[0] === "Projects"
        ? DataReports[1].fromDateString
        : Settings.Interval
        ? Settings.Interval.title === "ALL"
          ? ""
          : handleIntervalCalculation(
              Settings.Interval.title,
              "fromDate",
              Settings.Interval
            )
        : ""
    }${
      DataReports[0] === "Projects"
        ? DataReports[5]
          ? `&workspace=true`
          : DataReports[4] === "Account"
          ? `&userid=${DataReports[2].Id}`
          : DataReports[4] === "Department"
          ? `&department=${DataReports[2].Id}`
          : DataReports[4] === "organization"
          ? `&company=${DataReports[2] && DataReports[2].Id}`
          : `&team=${DataReports[2].Id}`
        : ""
    }`
  );
  var account = useCurrentAccount().Id;
  const user =
    DataReports[0] === "Projects" ? (
      DataReports[2]?.Name
    ) : (
      <FormattedMessage id={"ME"} />
    );
  if (!loading && !error) {
    const Results = data;
    return (
      <div className="px-3 of-hidden">
        <div className="d-flex justify-content-between">
          <DashboardTitle
            className="mb-0 fs-20"
            text={<FormattedMessage id={"PROJECTS_STATUS"} />}
          />
          <div>{/* <FontAwesomeIcon icon={faEllipsisV} /> */}</div>
        </div>
        {DataReports[0] !== "Projects" && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="mb-2">
              <span className="ar-dashboard-description">
                <FormattedMessage id={"INTERVAL"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {Settings.Interval && Settings.Interval.title !== "ALL" ? (
                  <FormattedMessage id={Settings.Interval.title} />
                ) : (
                  <FormattedMessage id={"ALL"} />
                )}
              </span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"SCOPE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">{user}</span>
              <span className="ar-dashboard-description ml-1">
                | <FormattedMessage id={"PIPELINE"} />:
              </span>
              <span className="text-primary pl-1 fs-14">
                {
                  getEntity(
                    spacePipelineSchema,
                    pipeline ? pipeline : Settings.Pipeline
                  )?.Name
                }
              </span>
            </div>
            <Button
              className="ar-dashboard-card-settings-link"
              vType="link-primary"
              onClick={() =>
                openSidebar(
                  <DashboardCardSettingsForm
                    lS_Field={lS_Field}
                    lS_Group={lS_Group}
                    Settings={Settings}
                    closeSidebar={closeSidebar}
                    pipelineType={1}
                    Title={"PROJECTS_STATUS"}
                    handleChanges={handleLayoutChange}
                    AvailableSettings={{
                      interval: true,
                      scope: true,
                      pipeline: true
                    }}
                  />
                )
              }
            >
              <FontAwesomeIcon icon={faCog} />
            </Button>
          </div>
        )}

        <div className="d-flex justify-content-between px-2">
          {Results.map((e, i) => {
            return (
              <div key={i} className="d-flex flex-column">
                <ProjectMainViewLink
                  className={classnames({
                    "ar-dashboard-active-values": e.PipelineStatus.Status === 1,
                    "ar-dashboard-closed-values": e.PipelineStatus.Status === 4,
                    "ar-dashboard-canceled-values":
                      e.PipelineStatus.Status === 3,
                    "ar-dashboard-draft-values": e.PipelineStatus.Status === 5
                  })}
                  params={`$filter=Project/PipelineStatusId eq '${
                    e.PipelineStatus.Id
                  }'${CreateDashboardFilterLinksHelper(
                    DataReports,
                    account
                  )}&pipeline=${pipeline}`}
                >
                  {e.Count}
                </ProjectMainViewLink>

                <div
                  className={classnames({
                    "ar-dashboard-active-description":
                      e.PipelineStatus.Status === 1,
                    "ar-dashboard-closed-description":
                      e.PipelineStatus.Status === 4,
                    "ar-dashboard-canceled-description":
                      e.PipelineStatus.Status === 3,
                    "ar-dashboard-draft-description":
                      e.PipelineStatus.Status === 5
                  })}
                >
                  {e.PipelineStatus?.Name}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  } else {
    return (
      <BarLoader style={{ marginTop: -16 }} isLoading={loading || error} />
    );
  }
};
